import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { Alert, AlertIcon, Button, Spinner, Stack } from "@chakra-ui/react";
import { AuthContext } from "context";
import { hasModulePermission, isSuperAdmin } from "utils/modulePermissions";

const ProtectedRoute = ({ children, moduleKey, superAdminOnly = false }) => {
  const { user, permissionsLoading, permissionsError, refreshPermissions } = useContext(AuthContext);

  if (!user) return <Navigate to="/auth/sign-in" replace />;
  if (permissionsLoading) return <Spinner aria-label="Cargando permisos" />;
  if (permissionsError) {
    return (
      <Stack>
        <Alert status="error"><AlertIcon />{permissionsError}</Alert>
        <Button alignSelf="start" onClick={() => refreshPermissions()}>Reintentar</Button>
      </Stack>
    );
  }
  if (!hasModulePermission(user, moduleKey) || (superAdminOnly && !isSuperAdmin(user))) {
    return <Navigate to="/admin/sin-acceso" replace />;
  }
  return children;
};

export default ProtectedRoute;
